module.exports = __webpack_public_path__ + "img/images_homebanner_5-1.bd96aaa0.png";